import env from './config/env';
import cookiePolicyUrl from './config/cookiePolicy';

import initStage from './services/stage';
import initAlia from './services/alia';

import * as snack from './services/snack';

import * as tooltips from './services/tooltips';
import * as messages from './services/message';
import initLoaders from './services/loading';
import initTranslate, { applyLang, translate } from './services/translate';

import query from './utils/query';

import mdcAutoInit from '@material/auto-init';

import { MDCList } from '@material/list';
import { MDCRipple } from '@material/ripple';
import { MDCSelect } from '@material/select';
import { MDCSnackbar } from '@material/snackbar';
import { MDCTextField } from '@material/textfield';
import { MDCTextFieldIcon } from '@material/textfield/icon';
import { MDCNotchedOutline } from '@material/notched-outline';
import { MDCSelectHelperText } from '@material/select/helper-text';
import { MDCTextFieldHelperText } from '@material/textfield/helper-text';

initStage();
initLoaders();
initAlia();
document.body.classList.add('loaded');

mdcAutoInit.register('MDCList', MDCList);
mdcAutoInit.register('MDCSelect', MDCSelect);
mdcAutoInit.register('MDCRipple', MDCRipple);
mdcAutoInit.register('MDCSnackbar', MDCSnackbar);
mdcAutoInit.register('MDCTextField', MDCTextField);
mdcAutoInit.register('MDCTextFieldIcon', MDCTextFieldIcon);
mdcAutoInit.register('MDCNotchedOutline', MDCNotchedOutline);
mdcAutoInit.register('MDCTextFieldHelperText', MDCTextFieldHelperText);
mdcAutoInit.register('MDCSelectHelperText', MDCSelectHelperText);

mdcAutoInit();

document.querySelector('.env').innerHTML = /production|dr/i.test(env) ? '' : env;
document.querySelector('#year').innerHTML = new Date().getFullYear();
document.querySelector('#policyCookies').src = cookiePolicyUrl;

const until = parseInt(query('until'), 10) || false;
const error = query('error');
const success = query('success');
const login = query('login');

initTranslate();
tooltips.init();

if (login && typeof login === 'string') {
  document.getElementById('login').value = login;
}

if (error) {
  const validationMessage = document.querySelector('.validationSign');
  const errorType = decodeURIComponent(error);

  snack.error(errorType);
  messages.error(errorType);

  if (/^pw/.test(errorType)) {
    validationMessage.classList.remove('hidden');

    applyLang(validationMessage, `errors.${errorType}`);
  }
}

if (success) {
  const successType = decodeURIComponent(success);

  snack.success(successType);
  messages.success(successType);
}

if (until) {
  messages.append(`. ${translate('errors.out-until')} ${new Date(until).toLocaleTimeString()}.`);
}
